<div class="statistic-wrapper">
  <div class="general-statistic">
    <div class="statistic-unit">
      <p class="label">{{ 'sources.General.StatisticAdditionalInfo.ProcessedPlacemarks' | translate }}</p>
      <h3 class="count">{{ getFieldValue(statistic?.ProcessedPlacemarksNumber) }}</h3>
    </div>
    <div class="statistic-unit">
      <p class="label">{{ 'sources.General.StatisticAdditionalInfo.TotalPlacemarks' | translate }}</p>
      <h3 class="count">{{ getFieldValue(statistic?.TotalPlacemarksNumber) }}</h3>
    </div>
  </div>
  <div class="additional-statistic">
    <div class="statistic-unit">
      <p class="label success">{{ 'sources.General.StatisticAdditionalInfo.Success' | translate }}</p>
      <h3 class="count">{{ statistic?.ProcessingResultsNumbers['Success/0'] }}</h3>
    </div>
    <div class="statistic-unit">
      <p class="label warning">{{ 'sources.General.StatisticAdditionalInfo.Warning' | translate }}</p>
      <h3 class="count">{{ statistic?.ProcessingResultsNumbers['Warning/1'] }}</h3>
    </div>
    <div class="statistic-unit">
      <p class="label errors">{{ 'sources.General.StatisticAdditionalInfo.Errors' | translate }}</p>
      <h3 class="count">{{ statistic?.ProcessingResultsNumbers['Error/2'] }}</h3>
    </div>
    <div class="statistic-unit">
      <p class="label">{{ 'sources.General.StatisticAdditionalInfo.Ignore' | translate }}</p>
      <h3 class="count">{{ statistic?.ProcessingResultsNumbers['Ignore/3'] }}</h3>
    </div>
  </div>
</div>
